<template>
	<tr>
		<td>
			<a :href="'/users/' + user.id +'/edit'" class="article-title"><strong>{{ user.name }}</strong></a>
			<div class="article-links">
				<a v-if="userRoles.includes('users.update')" :href="'/users/' + user.id +'/edit'">Edit</a>
			</div>
		</td>

		<td>{{ user.email }}</td>
		<td>{{ user.lastUpdated }}</td>
	</tr>
</template>

<script>
	export default {
		props: {
			dataUser: {
				type: Object,
			},
		},
		data() {
			return {
				user: this.dataUser,
				userRoles: this.$currentUserRoles,
			}
		}
	}
</script>
